import { Dispatch } from 'redux';

import {
  AreasOfFocus,
  fetchAreasOfFocus as apiFetchAreasOfFocus,
} from 'api/orgs';

import { setError } from './error';

export type MainStoreAreasOfFocusState = AreasOfFocus | null | undefined;

// Types

export type MainStoreAreasOfFocusAction = {
  type: 'AREAS_OF_FOCUS_SET';
  areasOfFocus: AreasOfFocus | null | undefined;
};

// Reducer

export function areasOfFocusReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: MainStoreAreasOfFocusState = null,
  action: MainStoreAreasOfFocusAction
) {
  switch (action.type) {
    case 'AREAS_OF_FOCUS_SET': {
      return action.areasOfFocus;
    }

    default:
      return state;
  }
}

// Actions

export const fetchAreasOfFocus =
  () =>
  (
    dispatch: Dispatch<MainStoreAreasOfFocusAction>,
    getState: () => { areasOfFocus: AreasOfFocus }
  ) => {
    if (getState().areasOfFocus) {
      return;
    }

    apiFetchAreasOfFocus()
      .then((areasOfFocus) => {
        dispatch({
          type: 'AREAS_OF_FOCUS_SET',
          areasOfFocus,
        });
      })
      .catch(setError);
  };
